<svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.2481 1.83205L7.13372 15.5036L0.847656 7.96028L3.15232 6.03972L6.86625 10.4964L13.7519 0.16795L16.2481 1.83205Z"
  />
</svg>
